module.exports = __webpack_public_path__ + "media/music/7a7fdb40997804d4778e2a12bd7599f7.mp3";